<template>
  <div class="card">
    <div class="card-header">
      <div class="utils__title">
        <strong>Kategorie - Přidat</strong>
      </div>
      <action-tools :router-options="routerOptions"></action-tools>
    </div>
    <div class="card-body">
      <div class="table-operations">
        <language-tab></language-tab>
      </div>
      <a-form :form="form" @submit="handleSubmit">
        <h4 class="text-black mt-4 mb-3"><strong>Nastavitelné podle jazyka</strong></h4>
        <a-form-item
          :validate-status="error('cle_name') ? 'error' : ''"
          :help="error('cle_name') || ''"
          label="Název"
        >
          <a-input placeholder="Název" v-decorator="['cle_name', {rules: [{max: 70, message: 'Název nemůže být delší než 70 znaků!'}, {required: true, message: 'Název musí být vyplněn!'}]}]"/>
        </a-form-item>

        <a-form-item
          :validate-status="error('cle_description') ? 'error' : ''"
          :help="error('cle_description') || ''"
          label="Popisek"
        >
          <a-input :autoSize="{ minRows: 4, maxRows: 10 }" type="textarea" placeholder="Popisek" v-decorator="['cle_description']"/>
        </a-form-item>

        <h4 class="text-black mt-4 mb-3"><strong>Ostatní</strong></h4>

        <a-form-item
          :label="'Skupiny (%)'"
          :required="true"
        >
          <a-row>
            <a-col :offset="2">
              <a-form-item
                v-for="(item, index) in groups"
                :key="'grp'+index"
                :label="item.grp_name"
                :validate-status="error(`group[${item.grp_id}]`) ? 'error' : ''"
                :help="error(`group[${item.grp_id}]`) || ''"
              >
                <a-input-number :step="0.01" style="width: 100%;" :min="0" :max="100" v-decorator="[`group[${item.grp_id}]`, { initialValue: 0, validateTrigger: ['change', 'blur'], rules: [{ required: true, message: 'Skupina musí být vyplněna!'}]}]"
                                :placeholder="item.grp_name"
                >
                </a-input-number>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form-item>

        <a-form-item label="Zveřejnit?">
          <a-checkbox v-decorator="['cey_is_active', { valuePropName: 'checked', initialValue: true }]"/>
        </a-form-item>

        <my-form-image-item
          title="Malý obrázek"
          decorator-name="existing_thumb"
          :image="thumbImage"
          :image-next-count="thumbImageNextCount"
          :images="thumbImages"
          :on-image-switch-change="onThumbImageSwitchChange"
          :on-next-images-click="onNextThumbImagesClick"
          :form="form"
        ></my-form-image-item>

        <my-form-image-item
          title="Hlavní obrázek"
          decorator-name="existing_breadcrumb"
          :image="breadcrumbImage"
          :image-next-count="breadcrumbImageNextCount"
          :images="breadcrumbImages"
          :on-image-switch-change="onBreadcrumbImageSwitchChange"
          :on-next-images-click="onNextBreadcrumbImagesClick"
          :form="form"
        ></my-form-image-item>

        <a-form-item
          label="Vyber rodiče kategorie"
        >
          <a-tree-select :allowClear="true" placeholder="-- Vyber rodiče kategorie --" :loading="item.cey_cey_id.loading" :treeData="treeData" v-decorator="['cey_cey_id']"></a-tree-select>
        </a-form-item>

        <div class="form-actions">
          <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(form.getFieldsError())">Přidat</a-button>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import LanguageTab from '@/components/MyComponents/LanguageTab'
import ActionTools from '@/components/MyComponents/ActionTools'
import { hasErrors } from '../../../../services/forms'
import myFormImageItem from '@/components/MyComponents/Gallery/my-form-image-item'
import breadcrumbImageMixin from '@/components/MyComponents/Gallery/breadcrumb-image-mixin'
import thumbImageMixin from '@/components/MyComponents/Gallery/thumb-image-mixin'

export default {
  components: { ActionTools, LanguageTab, myFormImageItem },
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  mixins: [breadcrumbImageMixin, thumbImageMixin],
  data: function () {
    return {
      hasErrors,
      dependencies: ['group_category_discounts', 'cey_cey_id'],
      loading: false,
      treeData: [],
      routerOptions: [
        {
          icon: 'bars',
          theme: 'outlined',
          to: '/ecommerce/category',
          title: 'Seznam',
        },
      ],
      item: {
        cey_cey_id: {
          loading: false,
        },
        group_category_discounts: {
          loading: false,
        },
        languages: [],
      },
      loaded: [],
    }
  },
  computed: {
    language: function() {
      return this.$store.getters['language/active']
    },
    categories: function() {
      return this.$store.getters['category/currentLanguage']
    },
    groups: function() {
      return this.$store.getters['group/active']
    },
  },
  methods: {
    initData() {
      this.dependencies.forEach((value) => {
        this.item[value].loading = true
      })
      Promise.all([
        this.$store.dispatch('group/getActive'),
        this.$store.dispatch('category/getList'),
      ])
        .catch(() => {})
        .finally(() => {
          this.dependencies.forEach((value) => {
            this.item[value].loading = false
          })
          this.loaded.push(this.language)
          this.treeData = this.toTreeNodeData(this.categories)
        })
    },
    toTreeNodeData(data) {
      return data.map(x => {
        return {
          key: '' + x.cey_id,
          value: '' + x.cey_id,
          title: '#' + x.cey_id + ' | ' + (x.languages[0] !== undefined ? x.languages[0].pivot.cle_name : 'není nenastaveno'),
          children: this.toTreeNodeData(x.all_children),
        }
      })
    },
    getData() {
      return {
        thumb_image_id: this.form.getFieldValue('existing_thumb') === undefined ? null : parseInt(this.form.getFieldValue('existing_thumb')),
        breadcrumb_image_id: this.form.getFieldValue('existing_breadcrumb') === undefined ? null : parseInt(this.form.getFieldValue('existing_breadcrumb')),
        cey_cey_id: this.form.getFieldValue('cey_cey_id') === undefined ? null : parseInt(this.form.getFieldValue('cey_cey_id')),
        cey_is_active: this.form.getFieldValue('cey_is_active'),
        languages: this.item.languages.filter(x => x.cle_name !== undefined && x.cle_name.trim().length > 0),
        group_category_discounts: this.groups.map(x => { return { grp_id: x.grp_id, gct_discount: this.form.getFieldValue('group[' + x.grp_id + ']') } }),
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.handleChange(this.language)
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$store.dispatch('category/post', this.getData())
            .catch(() => {})
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    handleChange(oldLanguage) {
      const foundObj = { item: false }
      const newObj = {
        item: {
          lge_id: oldLanguage,
          cle_name: this.form.getFieldValue('cle_name'),
          cle_description: this.form.getFieldValue('cle_description'),
        },
      }
      this.item.languages.some((value, key) => {
        if (value.lge_id === oldLanguage) {
          this.item.languages[key] = newObj.item
          foundObj.item = true
          return true
        }
      })
      if (!foundObj.item) {
        this.item.languages.push(newObj.item)
      }
    },
    error(fieldName) {
      const { getFieldError, isFieldTouched } = this.form
      return isFieldTouched(fieldName) && getFieldError(fieldName)
    },
  },
  created() {
    if (this.treeData.length === 0 && this.categories.length !== 0) {
      this.treeData = this.toTreeNodeData(this.categories)
    }
    if (this.language !== null && !this.loaded.includes(this.language)) {
      this.initData()
    }
  },
  watch: {
    language(newValue, oldValue) {
      if (oldValue !== null) {
        this.handleChange(oldValue)
      }
      if (newValue !== null) {
        this.treeData = this.toTreeNodeData(this.categories)
        const foundObj = { item: this.item.languages.find(x => x.lge_id === newValue) }
        let newObj
        if (foundObj.item === undefined) {
          newObj = {
            cle_name: undefined,
            cle_description: undefined,
          }
        } else {
          newObj = {
            cle_name: foundObj.item.cle_name,
            cle_description: foundObj.item.cle_description,
          }
        }
        this.form.setFieldsValue(newObj)
        if (!this.loaded.includes(this.language)) {
          this.initData()
        }
        this.form.validateFields()
      }
    },
    watch: {
      categories() {
        this.treeData = this.toTreeNodeData(this.categories)
      },
    },
  },
}
</script>
